import { render } from "./ShowImage.vue?vue&type=template&id=f74bafb6&scoped=true"
import script from "./ShowImage.vue?vue&type=script&lang=js"
export * from "./ShowImage.vue?vue&type=script&lang=js"

import "./ShowImage.vue?vue&type=style&index=0&id=f74bafb6&scoped=true&lang=css"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f74bafb6"]])

export default __exports__